import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Spinner from 'react16-spinjs';
import classNames from 'classnames';
import { READING_CHECK_WITH_MIC_TEXT } from '../../troConstants';
import { SPINNER } from '../../../constants/components';
import ReadingCheckSuccessCard from './ReadingCheckSuccessCard';
import MicCardContainer from '../instructions/InstructionCards/MicCardContainer';

class MicReadingCheckCard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isSuccessCardActive: false,
        };
    }

    componentDidMount() {
        const {
            passedReadingCheck,
            didAttemptMicReadingCheck,
            onFailure,
            trackFailedMicReadingCheck,
            trackStartPreAssessmentStep,
            isExternalURLSourcePresent,
            arLanguage,
            narrateScreen,
        } = this.props;
        if (didAttemptMicReadingCheck) {
            if (passedReadingCheck) {
                this.showSuccessScreen();
            } else {
                if(!isExternalURLSourcePresent) trackFailedMicReadingCheck();
                onFailure();
            }
        } else {
            narrateScreen(isExternalURLSourcePresent, arLanguage);
            if(!isExternalURLSourcePresent) trackStartPreAssessmentStep();
        }
    }

    componentDidUpdate(prevProps) {
        const {
            passedReadingCheck,
            didAttemptMicReadingCheck,
            onFailure,
            onSuccess,
            trackFailedMicReadingCheck,
            trackPassedReadingCheck,
            isExternalURLSourcePresent,
        } = this.props;

        if (passedReadingCheck && didAttemptMicReadingCheck && !prevProps.didAttemptMicReadingCheck) {
            onSuccess();
            this.showSuccessScreen();
            if (!isExternalURLSourcePresent) trackPassedReadingCheck();
        }
        if (!passedReadingCheck && didAttemptMicReadingCheck) {
            trackFailedMicReadingCheck();
            onFailure();
        }
    }

    componentWillUnmount() {
        this.props.cleanup();
    }

    renderSuccessCard = () => (
        <ReadingCheckSuccessCard text="Great Job!" onDone={this.props.onDone} />
    );

    showSuccessScreen = () => {
        this.setState({ isSuccessCardActive: true });
    };

    renderPromptCard = () => {
        const { isRecordingInProgress, isSpinnerVisible, passedMicReadingCheck } = this.props;

        return (
            <MicCardContainer
                {...this.props}
                isSpinnerVisible={isSpinnerVisible}
                isPassed={passedMicReadingCheck}
                hideArrowButton
            >
                <div className="reading-check-card">
                    <div className="instruction-content">
                        <div
                            className={classNames('target-text', {
                                highlight: isRecordingInProgress,
                            })}
                        >
                            {READING_CHECK_WITH_MIC_TEXT}
                        </div>
                        {isSpinnerVisible && <Spinner config={SPINNER.DARK} />}
                    </div>
                </div>
            </MicCardContainer>
        );
    };

    render() {
        const { isSuccessCardActive } = this.state;
        if (isSuccessCardActive) {
            return this.renderSuccessCard();
        }

        return this.renderPromptCard();
    }
}

MicReadingCheckCard.propTypes = {
    recordingStream: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    onSuccess: PropTypes.func.isRequired,
    onFailure: PropTypes.func.isRequired,
    cleanup: PropTypes.func.isRequired,
    narrateScreen: PropTypes.func.isRequired,
    isRecordingInProgress: PropTypes.bool.isRequired,
    isScreenBlocked: PropTypes.bool.isRequired,
    isSpinnerVisible: PropTypes.bool,
    saveRecordedResult: PropTypes.func,
    onDone: PropTypes.func.isRequired,
    passedReadingCheck: PropTypes.bool.isRequired,
    didAttemptMicReadingCheck: PropTypes.bool.isRequired,
    verificationStatus: PropTypes.string.isRequired,
    passedMicReadingCheck: PropTypes.bool.isRequired,
    isExternalURLSourcePresent: PropTypes.bool.isRequired,
    trackFailedMicReadingCheck: PropTypes.func.isRequired,
    trackPassedReadingCheck: PropTypes.func.isRequired,
    trackStartPreAssessmentStep: PropTypes.func.isRequired,
    arLanguage: PropTypes.string.isRequired,
};

MicReadingCheckCard.defaultProps = {
    recordingStream: false,
    isSpinnerVisible: false,
    saveRecordedResult: () => {},
};

export default MicReadingCheckCard;
